module.exports = "/_next/static/images/OgGoodData-ad03720670d39ad737b38b78a06738b9.png";